import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyframe"><Path d="M12.0002 1.08594L1.08594 12.0001L12.0002 22.9144L22.9144 12.0001L12.0002 1.08594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
